import * as ReactPopover from '@radix-ui/react-popover';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { forwardRef, memo } from 'react';

import { ChildrenType } from '../../api/types';

import './popover.scss';

export const Popover = ReactPopover.Root;

export const PopoverTrigger = ReactPopover.Trigger;

const PopoverContentUI = forwardRef(({ children, className, ...props }, forwardedRef) => (
  <ReactPopover.Portal>
    <ReactPopover.Content
      {...props}
      ref={forwardedRef}
      className={clsx('sb-Popover-content', className)}
      position="popper">
      {children}
    </ReactPopover.Content>
  </ReactPopover.Portal>
));

PopoverContentUI.propTypes = {
  children: ChildrenType.isRequired,
  className: PropTypes.string,
};

PopoverContentUI.defaultProps = {
  className: undefined,
};

export const PopoverContent = memo(PopoverContentUI);
